import * as angular from 'angular';
import { NgUtils } from "@fiqas/angular-utils";
export var FqComponents = NgUtils.DefineModule("FqComponents",[]);
export * from "./directives/focus";
export * from "./directives/timeFormatter";